import React from "react";
import { StyleSheet, View, Image } from "react-native";
import LinearGradient from "react-native-linear-gradient";

//Custom Imports
import color from "@constants/color";
import { scale } from "@utils/scale";
import CustomText from "@components/CustomText";
import { fontFamily } from "@utils/styles/fonts";

const ContestCard = ({ item = {} }) => {
  const { contest_banner = "", title = "" } = item;

  return (
    <React.Fragment>
      {contest_banner ? (
        <View style={styles.imageContainer}>
          <Image
            resizeMode={"stretch"}
            style={styles.liveBannerImage}
            source={{ uri: contest_banner }}
          />
        </View>
      ) : (
        <LinearGradient colors={[color.rgbaBlue, color.lightSkyBlue]}>
          <LinearGradient
            colors={[color.darkSkyBlue, color.trans_209_248]}
            style={styles.bannerContainer}
            useAngle={true}
          >
            <CustomText
              variant="title_18"
              newfont={true}
              numberOfLines={6}
              style={styles.cardTitle}
            >
              {title}
            </CustomText>
            <Image
              source={require("../../../assets/images/contest-celebration.png")}
              style={styles.bannerImage}
            />
          </LinearGradient>
        </LinearGradient>
      )}
    </React.Fragment>
  );
};

export default ContestCard;

const styles = StyleSheet.create({
  bannerContainer: {
    flexDirection: "column",
    padding: 16,
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginHorizontal: 16,
    minHeight: 163,
    overflow: "hidden",
  },
  imageContainer: {
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: 10,
    backgroundColor: color.white,
    marginHorizontal: 16,
    marginTop: 8,
    minHeight: 160,
    overflow: "hidden",
  },
  liveBannerImage: {
    minHeight: 160,
  },
  bannerImage: {
    width: 174,
    height: 163,
    position: "absolute",
    end: 0,
    alignSelf: "center",
  },
  cardTitle: {
    color: color.blueText,
    maxWidth: scale(161),
    lineHeight: 24,
    marginTop: 18,
  },
});
